import React, {Fragment, useEffect, useRef, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Button from "src/components/Common/Buttons/Button";
import CamvioTable2 from "src/components/UI/CamvioTable2";
import {createPaymentMethodForm, getMyPaymentMethods} from "src/actions/accountDetailsActions/payNow.actions";
import {getCurrentPaymentProviderId} from "src/actions/paymentProvider.actions";
import {getPaymentProviders, getUserPermission} from "src/selectors";
import {updateStripeCustomerId} from "src/actions/accountDetailsActions/accountDetails.actions";
import {toastr} from "react-redux-toastr";
import Loader from "src/components/Loader";



const PaymentMethods = ({accountInfo}) => {
    const dispatch = useDispatch()
    const currentProviderId = useSelector(state => getPaymentProviders(state).currentProviderId)
    const canViewStripeCustomerId = useSelector(state => getUserPermission(state, 'CAM', 'CAM_VIEW_STRIPE_CUSTOMER_ID'))
    const canEditStripeCustomerId = useSelector(state => getUserPermission(state, 'CAM', 'CAM_ACC_EDIT_STRIPE_CUSTOMER_ID'))
    const [paymentMethods, setPaymentMethods] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [tokenValue, setTokenValue] = useState('')
    const [isEditingStripeId, setIsEditingStripeId] = useState(false)
    const [stripeIdValue, setStripeIdValue] = useState(accountInfo.stripeCustomerId || '')
    const [isSavingStripeId, setIsSavingStripeId] = useState(false)
    const stripeIdInputRef = useRef(null)

    useEffect(() => {
        setStripeIdValue(accountInfo.stripeCustomerId || '')
    }, [accountInfo.stripeCustomerId]);

    useEffect(() => {
        if (isEditingStripeId && stripeIdInputRef.current) {
            stripeIdInputRef.current.focus()
        }
    }, [isEditingStripeId]);

    useEffect(() => {
        fetchPaymentMethods()
        if (!currentProviderId) {
            dispatch(getCurrentPaymentProviderId())
        }
    }, [currentProviderId]);

  const managePaymentMethods = () => {
    //we need a payment amount attribute to authenticate, payload is not actually used.
    let data = {
      paymentAmount:0,
      submitType: 'managePaymentMethods',
      paymentOption: 'ALL_UNPAID_INVOICES',
      accountInfo: accountInfo
    }

    // check if provider is Stripe and handle differently
    if (currentProviderId === 'STRIPE') {
      // For Stripe, make the API call directly and redirect with window.open
      dispatch(createPaymentMethodForm(accountInfo.id, data)).then((response) => {
        // Try to extract URL from various possible response structures
        let manageUrl = null;

        if (response && response.data && response.data.action) {
          manageUrl = response.data.action;
        } else if (response && response.action) {
          manageUrl = response.action;
        } else if (response && response.data && response.data.url) {
          manageUrl = response.data.url;
        } else if (response && response.url) {
          manageUrl = response.url;
        }

        if (manageUrl) {
          window.open(manageUrl, '_blank');
          toastr.success('Redirecting to Stripe payment methods management...', { position: "top-center" });
        } else {
          toastr.error('Failed to open Stripe payment methods management - no URL found', { position: "top-center" });
        }
      }).catch((error) => {
        toastr.error('Failed to open payment methods management', { position: "top-center" });
      });
    } else {
      // For nonStripe providers, use the existing form submission method
      let blurEventFired = false;

      window.addEventListener('blur', function() {
        blurEventFired = true;
      });

      dispatch(createPaymentMethodForm(accountInfo.id, data)).then((response) => {
        let managePaymentMethodForm = document.getElementById('managePaymentMethodForm');
        managePaymentMethodForm.action = response.data.action
        managePaymentMethodForm.target = response.data.target
        {Object.keys(response.data.fields).map((key) => {
          if (key === 'Token') {
            setTokenValue(response.data.fields[key])
          }
        })}
        managePaymentMethodForm.submit()

        setTimeout(function() {
          if (!blurEventFired) {
            alert('Your browser has a pop-up blocker enabled. Please disable via settings to Manage payment methods.');
          }
        }, 1000);
      })
    }
  }

    const fetchPaymentMethods = () => {
        setIsLoading(true)
        dispatch(getMyPaymentMethods(accountInfo.id))
            .then((response) => {
                setPaymentMethods(response)
                setIsLoading(false)
            });
    }


    const handleSaveStripeCustomerId = () => {
        if (!stripeIdValue || !stripeIdValue.trim()) {
            toastr.error('Stripe Customer ID is required', { position: 'top-center' })
            return
        }
        setIsSavingStripeId(true)
        dispatch(updateStripeCustomerId(accountInfo.id, stripeIdValue.trim()))
            .then((response) => {
                toastr.success('Stripe Customer ID updated successfully', { position: 'top-center' })
                setIsEditingStripeId(false)
                setIsSavingStripeId(false)
                setStripeIdValue(stripeIdValue.trim())
            })
            .catch((err) => {
                const data = err?.response?.data
                const message = data?.error?.message || (typeof data === 'string' ? data : 'Failed to update Stripe Customer ID')
                toastr.error(message, { position: 'top-center' })
                setIsSavingStripeId(false)
            })
    }

    const paymentMethodTypeFormatter = (type) => {
        switch(type) {
            case 'CREDIT_CARD':
                return <i className="fas fa-credit-card" title='Credit Card' />;
            case 'ACH':
                return <i className="fas fa-money-check" title='ACH' />;
            case 'WIRE_TRANSFER':
                return <i style={{color: '#8bc34a'}} className="fas fa-dollar-sign" title='Wire Transfer' />;
            case 'EXTERNAL':
                return <i className="fas fa-external-link-square-alt" title='External' />;
            case 'ACCOUNT_CREDIT':
                return <i style={{color: '#f48fb1'}} className="fas fa-piggy-bank" title='Account Credit' />;
            default:
                return <i className="fas fa-question" title='Unknown' />;
        }
    }



    return (
        <Fragment>
                    <div
                        style={{
                            display:'flex',
                            gap:'0.5rem',
                            marginTop: '0.5rem',
                            paddingTop: '0.5rem',
                            alignItems:'center',
                            justifyContent:'flex-end'
                        }}
                    >
                      {canViewStripeCustomerId && (
                        <div style={{marginRight:'auto'}}>
                          {isEditingStripeId ? (
                            <div className="input-group input-group-editable w-100">
                              <input
                                ref={stripeIdInputRef}
                                name="stripeCustomerId"
                                className="form-control"
                                value={stripeIdValue}
                                onChange={(e) => setStripeIdValue(e.target.value)}
                                disabled={isSavingStripeId}
                                autoComplete="off"
                                type="text"
                              />
                              <div className="input-group-append">
                                <button
                                  type="button"
                                  onClick={handleSaveStripeCustomerId}
                                  className="btn btn-primary btn-editable-apply"
                                  disabled={isSavingStripeId}
                                >
                                  {!isSavingStripeId ? (
                                    <i className="fas fa-check" />
                                  ) : (
                                    <i className="fas fa-spin fa-circle-notch" />
                                  )}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setIsEditingStripeId(false)
                                    setStripeIdValue(accountInfo.stripeCustomerId || '')
                                  }}
                                  className="btn btn-outline-secondary btn-editable-cancel"
                                  disabled={isSavingStripeId}
                                >
                                  <i className="fas fa-times" />
                                </button>
                              </div>
                            </div>
                          ) : (
                            accountInfo.stripeCustomerId && (
                              <span className="text-muted" style={{fontSize:'0.85rem'}}>
                                Stripe Customer Id:&nbsp;
                                {canEditStripeCustomerId ? (
                                  <a
                                    className="editable-generic-text"
                                    onClick={() => setIsEditingStripeId(true)}
                                  >
                                    {stripeIdValue.trim()}
                                  </a>
                                ) : (
                                  <span>{accountInfo.stripeCustomerId}</span>
                                )}
                              </span>
                            )
                          )}
                        </div>
                      )}
                        <Button
                            className='btn btn-primary btn-cn-add'
                            type="button"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                height: 'fit-content',
                            }}
                            onClick={() => fetchPaymentMethods()}
                        >
                            {isLoading ? "Refreshing..." : "Refresh"}
                        </Button>
                        <Button
                            className='btn btn-primary btn-cn-add'
                            type="button"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                height: 'fit-content',
                            }}
                            onClick={() => managePaymentMethods()}
                        >
                            Manage
                        </Button>
                        <form id="managePaymentMethodForm" method="post" action="" target="" style={{display: 'none'}}>
                            <input
                                name='Token'
                                placeholder='Token'
                                value={tokenValue}
                                style={{display: 'none'}}
                            />
                        </form>
                    </div>
            {isLoading ?
            <Loader/>
                :
                <CamvioTable2
                headerDefs={[
            {name: "Type", field: "type", sortable: false},
            {name: "Details", field: "displayCardNumber", sortable: false},
                ]}
                style={'striped'}
                >
                <tbody className='cmv-table '>
            {paymentMethods && paymentMethods.length ? paymentMethods.map((method, index) => (
                <tr key={`item_${method.id}`}>
                    <td style={{verticalAlign:'middle'}}>
                        <span>{paymentMethodTypeFormatter(method.type)}</span>
                    </td>
                    <td style={{verticalAlign:'middle', display:'flex', justifyContent:'center'}}>
                        <span>
                        {method.paymentInformation}
                        </span>
                    </td>
                </tr>
                ))
                :
                <tr>
                    <td style={{textAlign:'center'}} colSpan={2}>
                        No data found
                    </td>
                </tr>
            }
                </tbody>
                </CamvioTable2>
            }
        </Fragment>
    )
}
export default PaymentMethods
